
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.379 26.5H37.25a.75.75 0 00.75-.75v-3.5a.75.75 0 00-.75-.75H18.379v-2.879c0-1.336-1.616-2.005-2.561-1.06l-5.379 5.378a1.5 1.5 0 000 2.122l5.379 5.378c.945.945 2.56.276 2.56-1.06V26.5z","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    